module.exports = __webpack_public_path__ + "img/no_data.2c91b0f9.svg";